export const FIELDS_PROBLEM_IN_PURCHASE = [
  {
    name: 'rut',
    inputAdornment: '',
    label: 'RUT',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
  {
    name: 'orderId',
    inputAdornment: '',
    label: 'N° de orden de compra',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresar 8 , 9 u 11 dígitos',
  },
  {
    name: 'clientName',
    inputAdornment: '',
    label: 'Nombre completo',
    textArea: '',
    disabled: false,
    required: true,
  },
  {
    name: 'phone',
    inputAdornment: '',
    label: 'Teléfono',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresar 9 dígitos',
  },
  {
    name: 'email',
    inputAdornment: '',
    label: 'Correo actual',
    disabled: false,
    required: true,
  },
  {
    name: 'comment',
    multiline: true,
    rows: 4,
    inputAdornment: '',
    label: 'Escribir comentario',
    textArea: 'Escribir comentario',
    disabled: false,
    required: false,
    helper: '',
  },
];
